var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { InfoCircle, Success, Warning, Failure } from './icons';
import { Button } from './button';
export var Toastify = function (type, msg, position, // Default position set to 'top-right'
onClick) {
    if (position === void 0) { position = 'top-right'; }
    var title = '';
    switch (type) {
        case 'success':
            title = 'Success';
            break;
        case 'warning':
            title = 'Warning';
            break;
        case 'error':
            title = 'Error';
            break;
        case 'info':
            title = 'Info';
            break;
        default:
            title = 'Notification';
            break;
    }
    var toastContent = (_jsxs("div", { className: "flex flex-col w-full", children: [_jsx("p", { style: {
                    fontSize: '1rem',
                    letterSpacing: '-0.25px',
                    lineHeight: '1.5rem',
                    marginBottom: '4px',
                    fontWeight: '500',
                }, children: title }), _jsx("p", { style: {
                    fontSize: '1rem',
                    letterSpacing: '-0.25px',
                    lineHeight: '130%',
                    marginRight: '1rem',
                }, dangerouslySetInnerHTML: { __html: msg } }), onClick && (_jsx(Button, { variant: "outline", onClick: onClick, size: "sm", className: "mt-2 self-start bg-transparent border-background hover:text-foreground", children: "Action" }))] }));
    // Common toast options, including the position
    var toastOptions = {
        position: position, // Use the provided position or default to 'top-right'
        hideProgressBar: true,
        theme: 'colored',
        style: { cursor: 'default' },
    };
    switch (type) {
        case 'success':
            toast.success(toastContent, __assign(__assign({}, toastOptions), { className: 'toast-success-container toast-style-ltp', icon: _jsx(Success, { className: "w-6 h-6" }) }));
            break;
        case 'warning':
            toast.warn(toastContent, __assign(__assign({}, toastOptions), { className: 'toast-warning-container toast-style-ltp', icon: _jsx(Warning, { className: "w-6 h-6" }) }));
            break;
        case 'error':
            toast.error(toastContent, __assign(__assign({}, toastOptions), { className: 'toast-failure-container toast-style-ltp', icon: _jsx(Failure, { className: "w-6 h-6" }) }));
            break;
        case 'info':
            toast.info(toastContent, __assign(__assign({}, toastOptions), { className: 'toast-info-container toast-style-ltp', icon: _jsx(InfoCircle, { className: "w-6 h-6" }) }));
            break;
        default:
            toast.info(toastContent, __assign(__assign({}, toastOptions), { className: 'toast-info-container toast-style-ltp', icon: _jsx(InfoCircle, { className: "w-6 h-6" }) }));
            break;
    }
};
export default ToastContainer;
